import { useSelector } from 'react-redux';
import React, { Fragment } from 'react';
import { filter, flow, get, map } from 'lodash/fp';
import { Panel } from 'rsuite';
import PropTypes from 'prop-types';
import { DetailsItem, ItemLabel, ItemValue } from '../ViewElements';
import toCustomFieldValue from '../../../helpers/toCustomFieldValue';
import { getMainSettingsData } from '../../../redux/Settings/selectors/main';
import { VisitConfigsType } from '../../../interfaces';
import {
  ConfigOption,
  ConfigTypes
} from '../../../constants/visit/VisitConfig';
import SignatureBox from '../../SignatureBox';
import { RecordBy } from '../../../constants/tracking-method';
import toIdentityFieldValue from '../../../helpers/toIdentityFieldValue';
import { toDisplayDateTime } from '../../../helpers/dates';

const VisitDetails = ({ guestVisit, visitConfigs, visitCustomFields }) => {
  const settings = useSelector(getMainSettingsData);

  const createVisitConfigs = filter(
    ({ configType }) => configType === ConfigTypes.CREATE_VISIT,
    visitConfigs
  );

  return (
    <Panel>
      <DetailsItem>
        <ItemLabel>Visit Date</ItemLabel>
        <ItemValue>{toDisplayDateTime(get('visit_on', guestVisit))}</ItemValue>
      </DetailsItem>
      <DetailsItem>
        <ItemLabel>Location</ItemLabel>
        <ItemValue>{get('location.name', guestVisit)}</ItemValue>
      </DetailsItem>
      {map(
        config => (
          <Fragment key={config.id}>
            {config.configOption === ConfigOption.GUEST_NUMBER &&
              settings.createVisitShowinterviewNumShow === '1' && (
                <DetailsItem>
                  <ItemLabel>Guest #</ItemLabel>
                  <ItemValue>{get('interview_num', guestVisit)}</ItemValue>
                </DetailsItem>
              )}
            {config.configOption === ConfigOption.HELP_DESIRED && (
              <Fragment>
                <DetailsItem>
                  <ItemLabel>Help Desired</ItemLabel>
                  <ItemValue>{guestVisit.trackingMethod.label || ''}</ItemValue>
                </DetailsItem>
                <DetailsItem>
                  <ItemLabel>
                    {guestVisit.trackingMethod.recordBy ===
                      RecordBy.NO_OF_HOUSEHOLD && (
                      <span>Total Individuals</span>
                    )}
                    {guestVisit.trackingMethod.recordBy === RecordBy.WEIGHT && (
                      <span>Weight</span>
                    )}
                    {guestVisit.trackingMethod.recordBy === RecordBy.ITEMS && (
                      <span>Item(s)</span>
                    )}
                  </ItemLabel>
                  <ItemValue>{guestVisit.visitTrack.trackResult}</ItemValue>
                </DetailsItem>
              </Fragment>
            )}
            {config.configOption === ConfigOption.ID_PRESENTED &&
              (settings.createVisitIdent1 ||
                settings.createVisitIdent2 ||
                settings.createVisitIdent3) && (
                <DetailsItem>
                  <ItemLabel>ID Presented</ItemLabel>
                  <ItemValue>
                    {toIdentityFieldValue(settings, guestVisit)}
                  </ItemValue>
                </DetailsItem>
              )}
            {config.configOption === ConfigOption.SIGNATURE && (
              <DetailsItem>
                <ItemLabel>Signature</ItemLabel>
                <ItemValue>
                  <SignatureBox
                    signatureId={guestVisit.signature_id}
                    field="signature_id"
                  />
                </ItemValue>
              </DetailsItem>
            )}
            {config.configOption === ConfigOption.CUSTOM_FIELDS &&
              flow(
                filter(({ name }) => !!get(name, guestVisit)),
                map(field => (
                  <DetailsItem key={`cf-visits-${field.name}`}>
                    <ItemLabel>{field.label}</ItemLabel>
                    <ItemValue>
                      {toCustomFieldValue(guestVisit[field.name], field)}
                    </ItemValue>
                  </DetailsItem>
                ))
              )(visitCustomFields)}
          </Fragment>
        ),
        createVisitConfigs
      )}
      <DetailsItem>
        <ItemLabel>Volunteer Name</ItemLabel>
        <ItemValue>{guestVisit.volunteer.displayName}</ItemValue>
      </DetailsItem>
    </Panel>
  );
};

VisitDetails.propTypes = {
  visitConfigs: VisitConfigsType.isRequired,
  visitCustomFields: PropTypes.shape({}).isRequired,
  guestVisit: PropTypes.shape({
    id: PropTypes.number.isRequired,
    interview_num: PropTypes.number.isRequired,
    trackingMethod: PropTypes.shape({
      label: PropTypes.string.isRequired,
      recordBy: PropTypes.string.isRequired
    }),
    client_id: PropTypes.number.isRequired,
    signature_id: PropTypes.number.isRequired,
    volunteer: PropTypes.shape({
      id: PropTypes.number.isRequired,
      displayName: PropTypes.string.isRequired
    }).isRequired,
    visitTrack: PropTypes.shape({
      trackResult: PropTypes.number.isRequired
    })
  }).isRequired
};

export default VisitDetails;
